// extracted by mini-css-extract-plugin
export default {"profileDetails":"PersonalDetails_profileDetails__TRC91","personalDetails":"PersonalDetails_personalDetails__gnEuD"};